<tt-page *ngIf="page">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-page-heading ttModel="h_info" ttTranslate></tt-page-heading>
        <tt-input ttLabel="shift_id" [ttModel]="page.shift_id" ttReadonly></tt-input>
        <tt-input ttLabel="dayname" [ttModel]="page.day_name" ttReadonly></tt-input>
    </tt-card>
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-page-heading ttModel="h_start_time_end_time" ttTranslate></tt-page-heading>
        <tt-time ttLabel="in_time" [ttModel]="page.in_time" (ttModelChange)="onTimeChanged($event, 'in_time')" [ttMinutePrecision]="1"></tt-time>
        <tt-time ttLabel="out_time" [ttModel]="page.out_time" (ttModelChange)="onTimeChanged($event, 'out_time')" [ttMinutePrecision]="1"></tt-time>
    </tt-card>
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-page-heading ttModel="h_corrections_start_time_end_time" ttTranslate></tt-page-heading>
        <tt-time ttLabel="in_from_time" [(ttModel)]="page.in_from_time" [ttMinutePrecision]="1"></tt-time>
        <tt-time ttLabel="in_to_time" [(ttModel)]="page.in_to_time" [ttMinutePrecision]="1"></tt-time>
        <tt-time ttLabel="out_from_time" [(ttModel)]="page.out_from_time" [ttMinutePrecision]="1"></tt-time>
        <tt-time ttLabel="out_to_time" [(ttModel)]="page.out_to_time" [ttMinutePrecision]="1"></tt-time>
    </tt-card>
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-page-heading ttModel="h_salary_terms" ttTranslate></tt-page-heading>
        <tt-select ttLabel="salarytype" [(ttModel)]="page.salarytype_id" [ttData]="salaryTypes" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-checkbox ttLabel="core_rule" [(ttModel)]="page.core_rule"></tt-checkbox>
        <tt-checkbox ttLabel="include_in_capasity" [(ttModel)]="page.include_in_capasity"></tt-checkbox>
    </tt-card>
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-button-save ttText="save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
    </tt-card>
    <tt-card *ngIf="+params.shifttime_keyno > 0" class="col-xs-12 col-md-6 p-5">
        <tt-button ttText="delete" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteValues()"></tt-button>
    </tt-card>
</tt-page>
